import React from "react";
import { Container, Row, Col, Media } from "reactstrap";
import fixPolygon from "../images/fixPolygon.png";
import { joinCss } from "../helpers/utils";
import OpenFileLink from "../Components/OpenFileLink";

import appClasses from "../App.module.scss";
import classes from "./editionFixes.module.scss";

function editionFixes(props) {
  let toReturn = null;
  if (props.fixes && props.fixes.length > 0) {
    toReturn = (
      <div>
        <div className={joinCss(classes.editionHeader, "mt-3")}>
          תיקונים למהדורה {props.year}
        </div>
        <Container className="px-0">
          <Row>
            {props.fixes.map(element => (
              <Col md="6" lg="4" key={"Fix" + element.id}>
                <Container
                  className={joinCss(
                    appClasses.specificationCube,
                    appClasses["center-div"]
                  )}
                >
                  <Row>
                    <Col>
                      <Media
                        object
                        className={appClasses.polygonImg}
                        src={fixPolygon}
                        alt="דף תיקון"
                      />
                    </Col>
                  </Row>
                  <Row className={joinCss(appClasses.pdfRow)}>
                    <Col sm="12">
                      <OpenFileLink
                        localClass={joinCss(
                          appClasses["center-div"],
                          appClasses.localOpenFileClass
                        )}
                        contant={element.pdfName}
                        id={element.id}
                        fileName={element.id}
                      />
                    </Col>
                  </Row>
                </Container>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    );
  }

  return toReturn;
}

export default editionFixes;
